"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import { useWaveDropsLeaderboard } from "@/hooks/useWaveDropsLeaderboard";
import { WaveSmallLeaderboardDrop } from "./WaveSmallLeaderboardDrop";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useApprovalWaveStatus } from "@/hooks/waves/useApprovalWaveStatus";
interface WaveSmallLeaderboardProps {
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const WaveSmallLeaderboard: React.FC<WaveSmallLeaderboardProps> = t0 => {
  const $ = _c(24);
  const {
    wave,
    onDropClick
  } = t0;
  let t1;
  if ($[0] !== wave.id) {
    t1 = {
      waveId: wave.id
    };
    $[0] = wave.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    drops,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage
  } = useWaveDropsLeaderboard(t1);
  let t2;
  if ($[2] !== wave) {
    t2 = {
      wave
    };
    $[2] = wave;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    isVotingClosed,
    isVotingControlsLocked
  } = useApprovalWaveStatus(t2);
  const memoizedDrops = drops;
  let t3;
  if ($[4] !== fetchNextPage || $[5] !== hasNextPage || $[6] !== isFetching || $[7] !== isFetchingNextPage) {
    t3 = () => {
      if (hasNextPage && !isFetching && !isFetchingNextPage) {
        fetchNextPage();
      }
    };
    $[4] = fetchNextPage;
    $[5] = hasNextPage;
    $[6] = isFetching;
    $[7] = isFetchingNextPage;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const intersectionElementRef = useIntersectionObserver(t3);
  let t4;
  if ($[9] !== isFetching || $[10] !== isVotingClosed || $[11] !== isVotingControlsLocked || $[12] !== memoizedDrops || $[13] !== onDropClick || $[14] !== wave) {
    t4 = memoizedDrops.length === 0 && !isFetching ? <div className="tw-py-4 tw-text-center tw-text-iron-400">No drops have been made yet in this wave</div> : <ul className="tw-space-y-3 tw-pl-0">{memoizedDrops.map(drop => <WaveSmallLeaderboardDrop drop={drop} wave={wave} key={drop.id} isVotingClosed={isVotingClosed} isVotingControlsLocked={isVotingControlsLocked} onDropClick={() => onDropClick(drop)} />)}</ul>;
    $[9] = isFetching;
    $[10] = isVotingClosed;
    $[11] = isVotingControlsLocked;
    $[12] = memoizedDrops;
    $[13] = onDropClick;
    $[14] = wave;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== isFetchingNextPage) {
    t5 = isFetchingNextPage && <div className="tw-h-0.5 tw-w-full tw-overflow-hidden tw-bg-iron-800"><div className="tw-size-full tw-animate-loading-bar tw-bg-indigo-400" /></div>;
    $[16] = isFetchingNextPage;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== intersectionElementRef) {
    t6 = <div ref={intersectionElementRef} />;
    $[18] = intersectionElementRef;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t4 || $[21] !== t5 || $[22] !== t6) {
    t7 = <div className="tw-p-4"><div className="tw-flex tw-flex-col">{t4}{t5}{t6}</div></div>;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
};